import DOMPurify from 'dompurify';

function getMLV() {
  try {
    return window.config ? window.config.mlv : null;
  } catch (e) {
    return null;
  }
}

export const state = {
  drawer: true,
  mlv: getMLV(),
  title: null,
}

export const mutations = {
  setDrawer(state, drawer) {
    state.drawer = drawer
  },
  setTitle(state, title) {
    state.title = DOMPurify.sanitize(title);
  }
}

export const getters = {
  drawer: state => state.drawer,
  mlv: state => state.mlv,
  title: state => state.title,
}

export const actions = {
  closeDrawer({commit}) { // MLD-5641
    commit('setDrawer', false);
  },
  openDrawer({commit}) { // MLD-5641
    commit('setDrawer', true);
  },
  setDrawer({commit}, drawer) {
    commit('setDrawer', drawer);
  },
  setTitle({commit}, title) {
    commit('setTitle', title);
  }
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
}
